import React, { useState, createContext } from "react";

// Create Context
export const PropertyContext = createContext();

export const PropertyProvider = ({ children }) => {
    const [propertyUId, setPropertyUId] = useState(null);
    return <PropertyContext.Provider value={{ propertyUId, setPropertyUId }}>{children}</PropertyContext.Provider>;
};
